import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { MapService } from 'src/app/services/map/map.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.sass']
})
export class ProjectListComponent implements OnInit, OnDestroy {
  projects = new BehaviorSubject([])
  dataServiceSub: Subscription;
  currLoc;
  permissions: any;
  currentUser: any;

  constructor(
    private dataService: DataService,
    private mapService: MapService,
    private locationStore: LocationStoreService
  ) {}

  ngOnInit(): void {
    this.dataService.localStorageSub$.subscribe(res => {
      if (Object.keys(res).length === 0 && res.constructor === Object) {
        this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
      } else if (res.key === LS.currentUser) {
        this.currentUser = res.data
      }
      this.permissions = this.currentUser.permissions;
    })
    this.dataServiceSub = this.locationStore.locations$.subscribe(loc => {
      if (loc[0]) {
        this.currLoc = this.locationStore.currLocation$.getValue()
      }
      this.projects.next(loc)
    })
  }

  ngOnDestroy(): void {
    this.dataServiceSub.unsubscribe()
    this.mapService.removeAllMarker()
  }
}
